import { Pipe, PipeTransform } from '@angular/core';
import { Purchase } from '@greco/sales-purchases';

@Pipe({ name: 'purchaseSubtotal' })
export class PurchaseSubtotalPipe implements PipeTransform {
  transform(purchase: Purchase): number {
    return purchase.items.reduce((acc, item) => acc + item.price * item.quantity, 0);
  }
}
